export default "__VITE_ASSET__B3Rv7_RX__"